import '../scss/app.scss';
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger.js";
import {ScrollToPlugin} from "gsap/ScrollToPlugin.js";
import {initHeader} from "./components/header";
import lozad from "lozad";
import {initForm} from "./components/form";
import {initAdvantagesSlider} from "./components/advantages-slider";
import {initMainSlider} from "./components/main-slider";
import 'ion-rangeslider';
import {initMap} from "./components/map";
import {initLoadmore} from "./components/loadmore";
import {initModal} from "./components/modal";
import {initSelectOnFloorSlider} from "./components/select-on-floor-swiper";
import {initDrawingSVG} from "./components/drawing-svg";
import {initSmoothScroll} from "./components/animation";
import {initPlanSlider} from "./components/plan-slider";
import {initAnimations} from "./components/animations";


$(document).ready(function () {

    const observer = lozad('.lozad', {
        load: function (image) {
            if(image.tagName === 'DIV' || image.tagName === 'A') {
                $(image).css('background-image', 'url(' + image.dataset.background + ')');
            } else {
                $(image).attr('src', image.dataset.background);
            }
            image.classList.add('fade')
        }
    });

    observer.observe();

    // инициализация компонентов
    initHeader();
    initForm();
    initAdvantagesSlider();
    initMainSlider();
    initSelectOnFloorSlider();
    initMap();
    initLoadmore(observer);
    initModal(observer);
    initDrawingSVG();
    initSmoothScroll();
    initPlanSlider();
    initGsap();

    //Костыль для браузеров сафари на айфоне и андроиде с эджем
    const isSafariOniPhone = navigator.userAgent.match(/i(Phone|Pod|Pad).+Safari/);
    const isEdgeOnAndroid = navigator.userAgent.match(/Android.*Edg/);
    let prevHeight = $(window).height();
    const flatInfoMain = $('.main-screen').find('.flat-info');
    const mainScreen = $('.main-screen');
    if (isSafariOniPhone || isEdgeOnAndroid) {
        // mainScreen.css('height','100vh'); // установите желаемое значение
    }

    let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    $(window).on('resize', function() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    })

    function initGsap() {
        gsap.config({
            autoSleep: 60,
            force3D: true,
            trialWarn: false,
            autoKillThreshold: 1,
            units: {left: "%", top: "%", rotation: "rad"},
        });

        gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);
        ScrollTrigger.config({
            ignoreMobileResize: true,
        });

        ScrollTrigger.refresh();

        initAnimations();
    }

    // jQuery.scrollSpeed(1, 10);

/*    if($('.header-container').hasClass('white')){
        $('.header-container').find('.logo img').attr('src',"img/icons/logo_horizontal-dark.svg");
    }*/


    //переключение вида планировок 2д/3д

    $('.swiper-slide .view .plan').on('click',function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $(this).parents('.swiper-slide').find('.view-wrapper .plan[data-image-tab='+ $(this).data('image-tab') +']').addClass('active').siblings('.plan.active').removeClass('active')
            console.log($(this).parents('.view').siblings('.plan-image[data-image-tab=' + $(this).data('image-tab') +']'))
            $(this).parents('.view').siblings('.plan-image[data-image-tab=' + $(this).data('image-tab') +']').addClass('active').siblings('.plan-image.active').removeClass('active');
        }
    })

    $('.swiper-slide .view-mobile .plan').on('click',function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $(this).parents('.swiper-slide').find('.view .plan[data-image-tab='+ $(this).data('image-tab') +']').addClass('active').siblings('.plan.active').removeClass('active')
            console.log($(this).parents('.swiper-slide').find('.type-plan-wrapper'))
            $(this).parents('.swiper-slide').find('.type-plan-wrapper').find('.plan-image[data-image-tab=' + $(this).data('image-tab') +']').addClass('active').siblings('.plan-image.active').removeClass('active');
        }
    })

    $('.flat-wrapper .view .plan').on('click',function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $(this).parents('.flat-wrapper').find('.view-mobile .plan[data-image-tab='+ $(this).data('image-tab') +']').addClass('active').siblings('.view-mobile .plan.active').removeClass('active')
            console.log($(this).parents('.flat-wrapper').find('.view-mobile .plan[data-image-tab='+ $(this).data('image-tab') +']'))
            $(this).parents('.view').siblings('.plan-image[data-image-tab=' + $(this).data('image-tab') +']').addClass('active').siblings('.plan-image.active').removeClass('active');
        }
    })

    $('.flat-wrapper .view-mobile .plan').on('click',function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $(this).parents('.flat-wrapper').find('.view .plan[data-image-tab='+ $(this).data('image-tab') +']').addClass('active').siblings('.view .plan.active').removeClass('active')
            console.log($(this).parents('.flat-wrapper').find('.flat-plan').find('.plan-image[data-image-tab=' + $(this).data('image-tab') +']'))
            $(this).parents('.flat-wrapper').find('.flat-plan').find('.plan-image[data-image-tab=' + $(this).data('image-tab') +']').addClass('active').siblings('.plan-image.active').removeClass('active');
        }
    })

    //переключение типа планировок 1-2-3-4 комнаты

    $('.flat-room-select .room').on('click',function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $('.plan-tab[data-plan-tab=' + $(this).data('plan-tab') + ']').addClass('active').siblings('.active').removeClass('active');
            const roomWidth = $(this).outerWidth(true); // Ширина выбранного элемента, включая отступы
            const roomIndex = $(this).index(); // Индекс выбранного элемента в коллекции
            let prevRoomsWidth = 0; // Суммарная ширина предыдущих элементов
            for (let i = 0; i < roomIndex; i++) {
                prevRoomsWidth += $('.flat-room-select .room').eq(i).outerWidth(true);
            }
            const roomPosition = prevRoomsWidth - $('.flat-room-select').offset().left; // Рассчитываем позицию элемента относительно блока flat-room-select
            const scrollLeft = roomPosition - ($('.flat-room-select').width() / 2) + (roomWidth / 2); // Рассчитываем значение прокрутки блока
            $('.flat-room-select').animate({ scrollLeft: scrollLeft }, 500);
            const bulletCount = $('.swiper-pagination-bullet').length;
            const $nav = $('.plan-nav');

            if (bulletCount < 4 && window.innerWidth<1000) {
                $nav.css('left', 'calc(50% - 25px)');
            } else if (bulletCount == 4) {
                $nav.css('left', 'calc(50% - 50px)');
            }
        }
    })

    // Отключение контекстного меню для всех картинок, чтобы их не спи....
    $('.lozad').contextmenu(function (e){
        e.stopPropagation();
        e.preventDefault();
    })
    $('.animate').contextmenu(function (e){
        e.stopPropagation();
        e.preventDefault();
    })
    $('.resize-small-image').contextmenu(function (e){
        e.stopPropagation();
        e.preventDefault();
    })

    $('.tabs .tab-link').on('click', function (){
        if(!$(this).hasClass('active')){
            $(this).addClass('active').siblings('.active').removeClass('active');
            $('.search-container[data-tab=' + $(this).data('tab') + ']').addClass('active').siblings('.active').removeClass('active');
        }
    })

    document.addEventListener("keyup", function (e) {
        let keyCode = e.keyCode ? e.keyCode : e.which;
        if (keyCode == 44) {
            stopPrntScr();
        }
    });

    $('.search-text').on('click',function (){
        $(this).parents().find('.hided-content').slideToggle(300);
        $(this).toggleClass('active');
    })

    function stopPrntScr() {

        let inpFld = document.createElement("input");
        inpFld.setAttribute("value", ".");
        inpFld.setAttribute("width", "0");
        inpFld.style.height = "0px";
        inpFld.style.width = "0px";
        inpFld.style.border = "0px";
        document.body.appendChild(inpFld);
        inpFld.select();
        document.execCommand("copy");
        inpFld.remove(inpFld);
    }
    function AccessClipboardData() {
        try {
            window.clipboardData.setData('Text', 'Hello, world!');
        } catch (err) {
        }
    }
    setInterval(AccessClipboardData(), 300);


    // При прокрутке страницы, показываем или срываем кнопку
    $(window).scroll(function () {
        // Если отступ сверху больше 50px то показываем кнопку "Наверх"
        if ($(this).scrollTop() > 100) {
            $('#button-totop').css({
                'display': 'flex'
            });
        } else {
            $('#button-totop').css({
                'display': 'none'
            });
        }
    });

    // При нажатии на кнопку мы перемещаемся к началу страницы
    $('#button-totop').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 100);
        return false;
    });
})
